
  import { Component, Vue } from 'vue-property-decorator'

  import CartWidget from '@/components/cart/CartWidget.vue'
  import Price from '@/components/elements/Price.vue'
  import { LanguageStrings } from '@/language/types'

  @Component({
    name: 'MobileCartWidget',
    components: {
      CartWidget,
      Price,
    },
  })
  export default class MobileCartWidget extends Vue {
    t: LanguageStrings['mobileCartWidget']
    resizeObserver: ResizeObserver

    mounted() {
      const footerEl = this.$refs.footer as HTMLElement
      const style = document.body.style

      if (window.ResizeObserver) {
        this.resizeObserver = new ResizeObserver(() => {
          const height = footerEl.offsetHeight
          // When the element is hidden, the height is 0,
          // so we don't need to update the css prop
          if (height > 0) {
            style.setProperty('--mobile-cart-footer-height', `${height}px`)
          }
        })

        this.resizeObserver.observe(footerEl)
      }
    }

    get hideCheckoutButton() {
      return this.$route.name === 'checkout'
    }

    close() {
      this.$modals.close()
    }

    get moreEventsLinkProps() {
      return this.$route.name === 'events'
        ? { tag: 'button', class: 'button secondary more-events-button' }
        : { tag: 'a', class: 'more-events-button' }
    }
  }
